import React from 'react';
import { ArrowRight, Award, Clock, Shield } from 'lucide-react';
import WizardLauncher from './WizardLauncher';

const Hero: React.FC = () => {
  return (
    <section id="inicio" className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <div className="hero-promo-badge">
              🚀 ¡COMIENZA HOY! Moodle Listo para Usar
            </div>
            <h1 className="hero-title">
              <span className="highlight">Moodle Cloud</span> Completamente Administrado
            </h1>
            <p className="hero-subtitle">
              Tu plataforma Moodle lista para usar desde el primer día. Hosting optimizado, 
              administración completa y soporte 24/7. Comienza a enseñar inmediatamente sin 
              preocuparte por la tecnología - nosotros nos encargamos de todo.
            </p>
            
            <div className="hero-features">
              <div className="feature-item">
                <Shield className="feature-icon" />
                <span>Hosting Optimizado para Moodle</span>
              </div>
              <div className="feature-item">
                <Clock className="feature-icon" />
                <span>Listo en Minutos</span>
              </div>
              <div className="feature-item">
                <Award className="feature-icon" />
                <span>Administración Completa Incluida</span>
              </div>
            </div>

            <div className="hero-buttons">
              <WizardLauncher />
              <a href="#servicios" className="btn btn-secondary">
                Ver Servicios Moodle
              </a>
            </div>
          </div>
          
          <div className="hero-image">
            <div className="hero-illustration">
              <div className="moodle-mockup">
                <div className="mockup-header">
                  <div className="mockup-dots">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                  <div className="mockup-title">Moodle LMS</div>
                </div>
                <div className="mockup-content">
                  <div className="mockup-sidebar">
                    <div className="sidebar-item"></div>
                    <div className="sidebar-item"></div>
                    <div className="sidebar-item"></div>
                  </div>
                  <div className="mockup-main">
                    <div className="content-block"></div>
                    <div className="content-block"></div>
                    <div className="content-block small"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;